import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";
import { clinicInfo, getWhatsappUrl } from "@/config/site";
import banner from "../assets/1.jpg"

export default function ContactPage() {
  return (
    <PageTransition testId="contact-page">
      <PageHero
        title="Contact Kavlekar Dental"
        subtitle="Reach us easily for consultation guidance, location support, and appointments via WhatsApp."
        image={banner}
        testId="contact-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection
          className="grid gap-8 rounded-2xl border border-[#f2e6c9] bg-white p-7 md:grid-cols-2 md:p-10"
          testId="contact-info-main-section"
        >
          <div>
            <h2
              className="font-[Playfair_Display] text-3xl text-[#1a1a1a] md:text-4xl"
              data-testid="contact-info-title"
            >
              Visit Our Clinic
            </h2>
            <p
              className="mt-4 font-[Manrope] text-sm text-[#555555]"
              data-testid="contact-address-text"
            >
              {clinicInfo.address}
            </p>
            <p
              className="mt-4 font-[Manrope] text-sm text-[#555555]"
              data-testid="contact-phone-text"
            >
              Phone: {clinicInfo.phone}
            </p>

            <div className="mt-6 space-y-2" data-testid="contact-hours-list">
              {clinicInfo.hours.map((slot) => (
                <p
                  key={slot}
                  className="font-[Manrope] text-sm text-[#555555]"
                  data-testid={`contact-hours-item-${slot
                    .slice(0, 14)
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")}`}
                >
                  {slot}
                </p>
              ))}
            </div>

            <a
              href={getWhatsappUrl()}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex rounded-full bg-[#c5a059] px-6 py-3 font-[Manrope] text-xs font-semibold uppercase tracking-[0.16em] text-white hover:bg-[#b08d45]"
              data-testid="contact-whatsapp-button"
            >
              Chat on WhatsApp
            </a>
          </div>

          <div>
            <h3
              className="font-[Playfair_Display] text-2xl text-[#1a1a1a]"
              data-testid="contact-map-title"
            >
              Find us on Map
            </h3>
            <div
              className="mt-4 overflow-hidden rounded-2xl border border-[#f2e6c9]"
              data-testid="contact-map-wrapper"
            >
              <iframe
                title="Kavlekar Dental location map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.2610171205606!2d75.11642417493968!3d15.362343885219333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d737731fa873%3A0x10ace9e8a5f43141!2sKavlekar%20Dental!5e0!3m2!1sen!2sin!4v1775214925196!5m2!1sen!2sin"
                className="h-[320px] w-full"
                loading="lazy"
                data-testid="contact-map-iframe"
              />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
